import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-csrremarks',
  templateUrl: './csrremarks.component.html',
  styleUrls: ['./csrremarks.component.css'],
})
export class CsrremarksComponent implements OnInit {
  datas;
  /**
   * Constructs a new CsrremarksComponent.
   * @param data The data injected into the dialog.
   * @param dialogRef The reference to the dialog containing this component.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CsrremarksComponent>
  ) {
    // Store the injected data in a local variable
    this.datas = data;
  }

  ngOnInit(): void {}
  /**
   * Cancels the current operation.
   * Closes the dialog without performing any action.
   */
  cancelReason(): void {
    this.dialogRef.close();
  }
}
